import React from 'react';
import * as S from './styles';

const CheckImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/check.svg';

interface AccordionProps {
  title: string;
  isSelected: boolean;
  isMultipleSelect?: boolean;
  onSelectItem: () => void;
}

const renderPropperElement = (isMultipleSelect?: boolean) => {
  if (isMultipleSelect) return <img src={CheckImg} alt="check" />;
  else return <div />;
};

export const ItemFilter = ({ title, isSelected, isMultipleSelect, onSelectItem }: AccordionProps) => {
  return (
    <S.Container isSelected={isSelected} onClick={onSelectItem}>
      <S.Title>{title}</S.Title>
      <S.RadioButton isSelected={isSelected}>{isSelected && renderPropperElement(isMultipleSelect)}</S.RadioButton>
    </S.Container>
  );
};
